import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import { IActionType, IPaiyaGift } from "../../interfaces/Index";
import { uploadImageApiCall } from "utils/UploadImage";
import {
  createPaiyaGiftApiCall,
  fetchPaiyaGiftsApiCall,
} from "redux/sources/PaiyaGiftSource";

export const createPaiyaGiftInit = () => ({
  type: actionTypes.CREATE_PAIYA_GIFT_INIT,
});

export const createPaiyaGiftSuccess = () => ({
  type: actionTypes.CREATE_PAIYA_GIFT_SUCCESS,
});

export const createPaiyaGiftFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_PAIYA_GIFT_FAIL,
  error,
});

export const fetchPaiyaGiftInit = () => ({
  type: actionTypes.FETCH_PAIYA_GIFT_INIT,
});

export const fetchPaiyaGiftSuccess = (payload: Array<IPaiyaGift>) => ({
  type: actionTypes.FETCH_PAIYA_GIFT_SUCCESS,
  payload,
});

export const fetchPaiyaGiftFail = (error: string | object | null) => ({
  type: actionTypes.FETCH_PAIYA_GIFT_FAIL,
  error,
});

export const clearPaiyaGiftDetails = () => ({
  type: actionTypes.CLEAR_PAIYA_GIFT_DETAILS,
});

export const uploadImageAndCreatePaiyaGiftAction =
  (formData: FormData, payload: any) => (dispatch: Dispatch<IActionType>) => {
    dispatch(createPaiyaGiftInit());
    return uploadImageApiCall("gift", formData)
      .then((data: any) => {
        return data;
      })
      .then((data: any) => {
        payload.image = data.path || "";
        return createPaiyaGiftApiCall([payload])
          .then(() => dispatch(createPaiyaGiftSuccess()))
          .catch((e: object | null | string) => {
            dispatch(createPaiyaGiftFail(e));
          });
      })
      .catch((e: object | null | string) => dispatch(createPaiyaGiftFail(e)));
  };

export const fetchPaiyaGifts =
  (searchKey: string, giftType: string) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchPaiyaGiftInit());
    return fetchPaiyaGiftsApiCall(searchKey, giftType)
      .then((paiyaGifts: Array<IPaiyaGift>) => {
        dispatch(fetchPaiyaGiftSuccess(paiyaGifts));
      })
      .catch((e: object | null | string) => {
        dispatch(fetchPaiyaGiftFail(e));
      });
  };

export const clearPaiyaGiftsDetailsAction =
  () => (dispatch: Dispatch<IActionType>) => {
    dispatch(clearPaiyaGiftDetails());
  };
